/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meetings_Exception_Rule_NotetakerInputs */



/**
* | output |
* | --- |
* | "Notetaker" |
*
* @param {Meetings_Exception_Rule_NotetakerInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meetings_exception_rule_notetaker = /** @type {((inputs?: Meetings_Exception_Rule_NotetakerInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meetings_Exception_Rule_NotetakerInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Notetaker")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Notetaker")
	return /** @type {LocalizedString} */ ("Notetaker")
});